module.exports = __webpack_public_path__ + "img/bjh_video_play_icon.83f12bb8.png";